export default __webpack_public_path__ + "static/milkshake-991b911e403224e369a7a6ba3ec7fc04.ttf";